module.exports = __webpack_public_path__ + "static/media/online.aeefaca7.svg";